<template>
  <div class="chat-box">
    <div class="" :class="[sourceCode === 'aisino' ? 'aisino-service-nav' : 'service-nav']">
      <div class="nav-item" @click="setActive(-1)" :class="[sourceCode === 'aisino' ? (active === -1 ? ' aisino-nav-item aisino-active' : 'aisino-nav-item') : (active === -1 ? 'nav-item active' : 'nav-item')]">在这里问</div>
      <div class="nav-item" @click="setActive(-2)" :class="[sourceCode === 'aisino' ? (active === -2 ? ' aisino-nav-item aisino-active' : 'aisino-nav-item') : (active === -2 ? 'nav-item active' : 'nav-item')]">
        与我相关
        <div class="red-dot" v-if="isRead !==0"></div>
      </div>
      <div
        class="nav-item"
        v-for="(item,index) in tabList"
        :key="index"
        :class="[sourceCode === 'aisino' ? (active === index ? ' aisino-nav-item aisino-active' : 'aisino-nav-item') : (active === index ? 'nav-item active' : 'nav-item')]"
        @click="setActive(index)"
      >{{item.subscribe}}</div>
    </div>
    <service v-if="active === -1" @userUnRead="noRead"></service>
    <relevant v-if="active === -2" @userUnRead="noRead"></relevant>
    <div class="other" v-if="tabType === 2">
      <div class="other-item" v-html="tabContent"></div>
    </div>
  </div>
</template>

<script>
import service from "@/components/service.vue";
import relevant from "@/components/relevant.vue";
import { CHAT_API_DATA } from "@/api/chat";
import config from "@/config";
const mallUrl = config[process.env.NODE_ENV].mallUrl;
export default {
  name: "chat",
  components: {
    service,
    relevant,
  },
  props: [
    'tabList', //标签数组
  ],
  data() {
    return {
      // tabList: [], 
      tabType: 0, //标签类别
      tabContent: "", //标签内容
      contentList: [],
      active: -1,
      isRead: 0,
      isVip: 0,
      link: "", // 畅捷通购买会员地址
      sourceCode: '',
    };
  },
  computed: {
    ISVIP () {
      return this.$store.state.isVip
    }
  },
  created() {
    this.userUnRead();
  },
  mounted() {
    this.sourceCode = this.$route.query.sourceCode;
    this.isVip = this.$store.state.isVip
    this.link =
      process.env.NODE_ENV == "development"
        ? "https://inte-store.chanjet.com/purchase?&agentCode=&csparam=&productId=4347&channel=asktax&buyAgain=1&orgId=" +
          this.$route.query.orgId +
          "&successBackBtnLabel=%e5%90%8c%e6%84%8f%e6%89%8b%e6%9c%ba%e5%8f%b7%e6%8e%88%e6%9d%83%e5%b9%b6%e4%bd%93%e9%aa%8c&callback=https%3a%2f%2finte-www.chanjet.com%2fnews%2ff%2f101593.html"
        : "https://store.chanjet.com/wap/purchase?&agentCode=&csparam=&productId=4347&channel=asktax&buyAgain=1&orgId=" +
          this.$route.query.orgId +
          "&successBackBtnLabel=%e5%90%8c%e6%84%8f%e6%89%8b%e6%9c%ba%e5%8f%b7%e6%8e%88%e6%9d%83%e5%b9%b6%e4%bd%93%e9%aa%8c&callback=https%3a%2f%2fwww.chanjet.com%2fnews%2ff%2f102658.html";
  },
  methods: {
    //未读提醒
    noRead(data) {
      this.isRead = data;
    },
    //未读提醒
    userUnRead() {
      CHAT_API_DATA.userUnRead()
        .then((res) => {
          this.isRead = res.data;
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //设置活动标签
    setActive(val) {
      const arr = this.tabList;
      if (parseInt(this.isVip.vip) === 1) {
        switch (val) {
          case -1:
            this.tabType = 0;
            break;
          case -2:
            this.tabType = 0;
            break;
          default:
            if (arr[val].type === 3) {
              // window.location.href = arr[val].introduce;
              this.$router.push( '/webview?' + window.location.search + '&url=' + arr[val].introduce)
            } else {
              this.tabType = arr[val].type;
              this.tabContent = arr[val].introduce;
            }
            break;
        }
        this.active = val;
      } else if (parseInt(this.isVip.vip) === 0 && val !== -1) {
        if (this.$store.state.cjt === true) {
          // window.location.href = this.link;
          this.$confirm("该功能仅限付费用户使用，前往购买会员?", "提示", {
            confirmButtonText: "前往",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            //判断 是否需要跳转后台传递的购买链接 liyanze-分支增加
            let isBuy =  sessionStorage.getItem("cjtIsHavePay");
            if(isBuy == 'yes'){
              let buyUrl =  sessionStorage.getItem("cjtPayUrl"); 
              window.open(buyUrl);
            }else{
              window.open(this.link);
            }
            //window.open(this.link)
          }).catch(() => {

          })
          // window.open(this.link)
        } else {
          this.$confirm("该功能仅限付费用户使用，前往购买会员?", "提示", {
            confirmButtonText: "前往",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            window.open(mallUrl)
          }).catch(() => {

          })
          // window.open(mallUrl)
        }
      }
    },
  },
  watch: {
    ISVIP: function (val) {
      this.isVip = val
    }
  }
};
</script>

<style scoped>
.chat-box {
  display: grid;
  grid-template-rows: auto 1fr;
}
.service-nav {
  display: flex;
  display: -webkit-flex;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}

.nav-item {
  float: left;
  padding: 15px 0;
  margin: 0 59px 0 15px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #222222;
  cursor: pointer;
}

.active {
  font-family: "微软雅黑";
  font-weight: bold;
  color: #2270e6;
  border-bottom: 1px solid #2270e6;
}

.red-dot {
  background-color: #ee6464;
  border-radius: 50%;
  height: 10px;
  width: 10px;
  float: right;
}
.other-item {
  display: grid;
  width: 100%;
  grid-template-columns: auto;
  grid-template-rows: 1fr;
}
.other-item >>> p {
  width: 100%;
  line-height: 2rem;
}
.other-item >>> img {
  width: 100%;
}

/* 定制版CSS */
.aisino-service-nav{
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  text-align: center;
  width: 100%;
  margin-top: 20px;
  /* border-bottom: 1px solid #eeeeee; */
}
.aisino-nav-item {
  float: left;
  padding: 5px 20px;
  margin: 0 59px 0 15px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #9a9a9a;
  cursor: pointer;
}
.aisino-active {
  font-family: "微软雅黑";
  font-weight: bold;
  color: #4a4a4a;
  border: 1px solid #00b7ee;
  border-radius: 5px;
}
</style>